import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=3993f3de&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenha.vue?vue&type=style&index=0&id=3993f3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993f3de",
  null
  
)

export default component.exports